module.exports = __webpack_public_path__ + "img/regProp-3.c8c33773.jpg";